// @ts-check
import {Link} from "gatsby"
import React from "react"

// TODO: add icon to plain Button or make a IconButton
// TODO: refactor
const BASIC_BUTTON_CLASS = "btn"

/**
 * @typedef {React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>} RawButtonProps
 * @typedef {React.PropsWithChildren<{
 *  type?: 'primary' | 'secondary' | 'accent'
 *  outline?: boolean
 *  plain?:boolean
 *  disabled?: boolean
 *  className?: string
 *  path?: string | null,
 * }>} ButtonProps
 */

/** @type {React.FC<ButtonProps & Omit<RawButtonProps, "type">>} */
const Button = ({
  children,
  type = "primary",
  outline = false,
  plain = false,
  disabled = false,
  className = "",
  path,
  ...props
}) => {
  const getButtonThemeClass = () => {
    let themeClass = [BASIC_BUTTON_CLASS]
    if (disabled) {
      themeClass.push("btn--disable")
    } else {
      const [theme, suffix] = type.split("-")
      const isOutlined = suffix === "outlined" || outline
      const isPlain = suffix === "plain" || plain
      if (isOutlined) {
        themeClass.push("btn--outline")
      } else if (isPlain) {
        themeClass.push("btn--plain")
      }
      themeClass.push(`btn-${theme}`)
    }
    // escape pod
    themeClass.push(className)
    return themeClass.join(" ")
  }

  return React.createElement(
    path ? Link : "div",
    // @ts-ignore
    {
      ...props,
      tabIndex: 0,
      role: "button",
      className: getButtonThemeClass(),

      ...(path
        ? {
            to: path,
          }
        : undefined),
    },
    children,
  )
}

// class white list, prevent tailwind clear this
// maybe need put in safeList
// btn-primary btn-secondary btn-accent

export default Button
